const youtube = {
  scriptLoaded: false,
  player: '',
  elModal: '',
  elBtns: '',
  onClick: () => '',
  init() {
    this.videoBtns()

    return this.player
  },
  videoBtns() {
    this.elBtns.listen('click', (btn, e) => {
      const videoID = this.parseUrl(btn.dataset.video).v

      e.preventDefault()

      this.loadYTPlayer()
      this.onClick()

      if (this.player) this.player.destroy()

      const YTinterval = setInterval(() => {
        if (typeof YT != 'undefined') {
          this.player = new YT.Player('ytplayer', {
            videoId: videoID,
            events: {
              onReady: onPlayerReady
            }
          })

          clearInterval(YTinterval)
        }
      }, 1000)

      function onPlayerReady(event) {
        event.target.playVideo()
      }
    })
  },
  loadYTPlayer() {
    if (this.scriptLoaded) return
    this.scriptLoaded = true

    const tag = document.createElement('script')

    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  },
  parseUrl(url) {
    const regex = /[?&]([^=#]+)=([^&#]*)/g
    const params = {}
    let match

    while ((match = regex.exec(url))) params[match[1]] = match[2]

    return params
  }
}
export default youtube
